module.exports = __webpack_public_path__ + "img/img7.4ab1818d.jpg";